import { SxProps, Theme } from "@mui/material";
import { assessmentPhoneLandscapeMedia, assessmentShortViewportMedia } from "../../assessment-layout-styles";

export const containerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: "4px", sm: "8px", md: "16px" },
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  [assessmentShortViewportMedia]: {
    gap: "4px",
  },
};

export const headerTopRowStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row", md: "row" },
  gap: { xs: "8px", sm: "8px", md: "24px" },
  alignItems: { xs: "center", sm: "center", md: "center" },
  justifyContent: { xs: "center", sm: "space-between", md: "space-between" },
  width: "100%",
  minWidth: 0,
  flexWrap: { xs: "nowrap", sm: "nowrap", md: "nowrap" },
};

export const timerAndProgressContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "row", sm: "row", md: "row" },
  gap: { xs: "12px", sm: "8px", md: "0px" },
  alignItems: { xs: "flex-start", sm: "center", md: "center" },
  justifyContent: {
    xs: "space-between",
    sm: "flex-start",
    md: "flex-start",
  },
  width: { xs: "100%", sm: "auto", md: "auto" },
  minWidth: 0,
  flex: { xs: "1 1 auto", sm: "1 1 0%", md: "1 1 0%" },
  [assessmentShortViewportMedia]: {
    gap: "8px",
  },
};

export const progressContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: { xs: 1, sm: "1 1 0%", md: "1 1 0%" },
  mx: { xs: "0", sm: "8px", md: "40px" },
  justifyContent: { xs: "center", sm: "center", md: "center" },
  minWidth: 0,
  maxWidth: "none",
  width: { xs: "auto", sm: "100%", md: "100%" },
  alignSelf: { xs: "flex-start", sm: "auto", md: "auto" },
  mt: { xs: 0, sm: "10px", md: "10px" },
};

export const progressRowStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  gap: "5px",
};

export const progressLabelStyle: SxProps<Theme> = {
  color: "#06B6D4",
  fontSize: { xs: "14px", sm: "14px", md: "16px" },
  fontWeight: 600,
  [assessmentPhoneLandscapeMedia]: {
    fontSize: "12px",
  },
  [assessmentShortViewportMedia]: {
    fontSize: "12px",
  },
};

export const linearProgressStyle: SxProps<Theme> = (theme) => ({
  height: 10,
  borderRadius: 4,
  backgroundColor: theme.palette.quizPopap.quizLineBg,
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(90deg, #8957CF 0%, #28C9DC 100%)",
  },
  [assessmentShortViewportMedia]: {
    height: 6,
  },
});

export const resultsCircleWrapperStyle: SxProps<Theme> = {
  display: { xs: "none", sm: "none", md: "block" },
  flexShrink: 0,
};

export const mobileSubheaderRowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  width: "100%",
  minWidth: 0,
};

export const mobileQuestionLabelStyle: SxProps<Theme> = {
  fontWeight: 600,
  color: "#06B6D4",
  fontSize: "16px",
  flexShrink: 0,
  [assessmentPhoneLandscapeMedia]: {
    fontSize: "13px",
  },
  [assessmentShortViewportMedia]: {
    fontSize: "13px",
  },
};
